module.exports = __webpack_public_path__ + "img/_DSC1155.1a75736e.jpg";